import { Theme } from '../../../src/types/index.js'

export const theme: Theme = {
  id: 'ornamentes',
  name: 'Ornamentes',
  palette: {
    primary: '#1164A3',
    accent: '#1164A3',
    neutral: '#F0E4F0',
  },
  light1: {
    'action-primary': '#2d76b4',
    'action-primary-hovered': '#005693',
    'action-primary-pressed': '#004176',
    'action-primary-subdued': '#f5f8fc',
    'action-primary-subdued-hovered': '#edf3fa',
    'action-primary-subdued-pressed': '#dbe8f5',
    'action-primary-disabled': '#fff6ff',
    'action-neutral': '#FFFFFF',
    'action-neutral-hovered': '#fff6ff',
    'action-neutral-pressed': '#faeefa',
    'action-neutral-subdued': '#faeefa',
    'action-neutral-subdued-hovered': '#efe3ef',
    'action-neutral-subdued-pressed': '#dcd1dc',
    'action-neutral-disabled': '#FFFFFF',
    'action-destructive': '#d83028',
    'action-destructive-hovered': '#a71613',
    'action-destructive-pressed': '#840a08',
    'action-destructive-subdued': '#fff5f3',
    'action-destructive-subdued-hovered': '#fff0ec',
    'action-destructive-subdued-pressed': '#ffe0da',
    'action-destructive-disabled': '#faeefa',
    background: '#faeefa',
    'background-hovered': '#efe3ef',
    'background-pressed': '#dcd1dc',
    'background-selected': '#dcd1dc',
    'background-backdrop': '#00000080',
    'background-overlay': '#ffffff80',
    'background-divider': '#a99fa9',
    content: '#070607',
    'content-subdued': '#585258',
    'content-muted': '#777077',
    'content-hovered': '#191619',
    'content-pressed': '#585258',
    'content-disabled': '#a99fa9',
    'content-on-positive': '#004b22',
    'content-on-attention': '#663200',
    'content-on-highlight': '#00284f',
    'content-on-negative': '#840a08',
    'content-on-negative-hovered': '#580202',
    'content-on-negative-pressed': '#380101',
    'content-primary': '#00284f',
    'content-on-primary': '#FFFFFF',
    'content-on-inverse': '#fff6ff',
    'content-on-destructive': '#FFFFFF',
    'content-on-interactive': '#FFFFFF',
    'content-on-background': '#070607',
    'content-on-background-subdued': '#585258',
    'content-on-background-hovered': '#191619',
    'content-on-background-pressed': '#585258',
    'content-on-background-disabled': '#a99fa9',
    interactive: '#005693',
    'interactive-hovered': '#004176',
    'interactive-pressed': '#00284f',
    'interactive-disabled': '#fff6ff',
    'interactive-destructive': '#d83028',
    'interactive-destructive-hovered': '#a71613',
    'interactive-destructive-pressed': '#840a08',
    'interactive-destructive-disabled': '#fff6ff',
    topbar: '#5b2c5c',
    'topbar-subdued': '#451e46',
    'content-on-topbar': '#fff7ff',
    'line-on-topbar': '#dcd1dc',
    'line-on-topbar-pressed': '#777077',
    link: '#005693',
    'link-hovered': '#7fb4e0',
    'link-pressed': '#00284f',
    line: '#dcd1dc',
    'line-subdued': '#efe3ef',
    'line-hovered': '#a99fa9',
    'line-pressed': '#777077',
    'line-selected': '#585258',
    'line-disabled': '#efe3ef',
    'line-transparent': '#0000001a',
    'line-positive': '#00612f',
    'line-positive-subdued': '#90e6af',
    'line-highlight': '#005693',
    'line-highlight-subdued': '#bfd7ee',
    'line-negative': '#a71613',
    'line-negative-subdued': '#ffc7bc',
    'line-negative-disabled': '#ffe0da',
    'line-attention': '#844200',
    'line-attention-subdued': '#ffcb89',
    focused: '#005693',
    skeleton: '#efe3ef',
    surface: '#FFFFFF',
    'surface-subdued': '#faeefa',
    'surface-hovered': '#faeefa',
    'surface-subdued-hovered': '#efe3ef',
    'surface-pressed': '#efe3ef',
    'surface-disabled': '#fff6ff',
    'surface-selected': '#f5f8fc',
    'surface-selected-hovered': '#edf3fa',
    'surface-selected-pressed': '#dbe8f5',
    'surface-attention': '#ffe2bb',
    'surface-attention-subdued': '#fff7ed',
    'surface-negative': '#ffe0da',
    'surface-negative-subdued': '#fff5f3',
    'surface-negative-subdued-hovered': '#fff0ec',
    'surface-negative-subdued-pressed': '#ffe0da',
    'surface-positive': '#c1f2d0',
    'surface-positive-subdued': '#f2fbf5',
    'surface-highlight': '#dbe8f5',
    'surface-highlight-subdued': '#f5f8fc',
    'surface-highlight-subdued-hovered': '#edf3fa',
    'surface-highlight-subdued-pressed': '#dbe8f5',
    'surface-neutral': '#efe3ef',
    'surface-neutral-subdued': '#fff6ff',
    'surface-inverse': '#191619',
    'decorative-surface-1': '#FFC96B',
    'decorative-surface-1-subdued': '#FFE4B5',
    'decorative-content-1': '#7E5700',
    'decorative-surface-2': '#FFC4B0',
    'decorative-surface-2-subdued': '#FFE1D7',
    'decorative-content-2': '#AF294E',
    'decorative-surface-3': '#92E6B5',
    'decorative-surface-3-subdued': '#C9F3DA',
    'decorative-content-3': '#006D41',
    'decorative-surface-4': '#91E0D6',
    'decorative-surface-4-subdued': '#C8EFEB',
    'decorative-content-4': '#006A68',
    'decorative-surface-5': '#FDC9D0',
    'decorative-surface-5-subdued': '#FEE4E7',
    'decorative-content-5': '#AE2B4C',
    'decorative-surface-6': '#7CD4FD',
    'decorative-surface-6-subdued': '#BDE9FE',
    'decorative-content-6': '#065986',
    'decorative-surface-7': '#BDB4FE',
    'decorative-surface-7-subdued': '#DED9FF',
    'decorative-content-7': '#4A1FB8',
  },
  light2: {
    'action-primary': '#2d76b4',
    'action-primary-hovered': '#005693',
    'action-primary-pressed': '#004176',
    'action-primary-subdued': '#f5f8fc',
    'action-primary-subdued-hovered': '#edf3fa',
    'action-primary-subdued-pressed': '#dbe8f5',
    'action-primary-disabled': '#fff6ff',
    'action-neutral': '#FFFFFF',
    'action-neutral-hovered': '#fff6ff',
    'action-neutral-pressed': '#faeefa',
    'action-neutral-subdued': '#faeefa',
    'action-neutral-subdued-hovered': '#efe3ef',
    'action-neutral-subdued-pressed': '#dcd1dc',
    'action-neutral-disabled': '#FFFFFF',
    'action-destructive': '#d83028',
    'action-destructive-hovered': '#a71613',
    'action-destructive-pressed': '#840a08',
    'action-destructive-subdued': '#fff5f3',
    'action-destructive-subdued-hovered': '#fff0ec',
    'action-destructive-subdued-pressed': '#ffe0da',
    'action-destructive-disabled': '#faeefa',
    background: '#FFFFFF',
    'background-hovered': '#faeefa',
    'background-pressed': '#efe3ef',
    'background-selected': '#efe3ef',
    'background-backdrop': '#00000080',
    'background-overlay': '#ffffff80',
    'background-divider': '#a99fa9',
    content: '#070607',
    'content-subdued': '#585258',
    'content-muted': '#777077',
    'content-hovered': '#191619',
    'content-pressed': '#585258',
    'content-disabled': '#a99fa9',
    'content-on-positive': '#004b22',
    'content-on-attention': '#663200',
    'content-on-highlight': '#00284f',
    'content-on-negative': '#840a08',
    'content-on-negative-hovered': '#580202',
    'content-on-negative-pressed': '#380101',
    'content-primary': '#00284f',
    'content-on-primary': '#FFFFFF',
    'content-on-inverse': '#fff6ff',
    'content-on-destructive': '#FFFFFF',
    'content-on-interactive': '#FFFFFF',
    'content-on-background': '#070607',
    'content-on-background-subdued': '#585258',
    'content-on-background-hovered': '#191619',
    'content-on-background-pressed': '#585258',
    'content-on-background-disabled': '#a99fa9',
    interactive: '#005693',
    'interactive-hovered': '#004176',
    'interactive-pressed': '#00284f',
    'interactive-disabled': '#fff6ff',
    'interactive-destructive': '#d83028',
    'interactive-destructive-hovered': '#a71613',
    'interactive-destructive-pressed': '#840a08',
    'interactive-destructive-disabled': '#fff6ff',
    topbar: '#FFFFFF',
    'topbar-subdued': '#faeefa',
    'content-on-topbar': '#070607',
    'line-on-topbar': '#dcd1dc',
    'line-on-topbar-pressed': '#777077',
    link: '#005693',
    'link-hovered': '#004176',
    'link-pressed': '#00284f',
    line: '#dcd1dc',
    'line-subdued': '#efe3ef',
    'line-hovered': '#a99fa9',
    'line-pressed': '#777077',
    'line-selected': '#585258',
    'line-disabled': '#efe3ef',
    'line-transparent': '#0000001a',
    'line-positive': '#00612f',
    'line-positive-subdued': '#90e6af',
    'line-highlight': '#005693',
    'line-highlight-subdued': '#bfd7ee',
    'line-negative': '#a71613',
    'line-negative-subdued': '#ffc7bc',
    'line-negative-disabled': '#ffe0da',
    'line-attention': '#844200',
    'line-attention-subdued': '#ffcb89',
    focused: '#005693',
    skeleton: '#efe3ef',
    surface: '#FFFFFF',
    'surface-subdued': '#faeefa',
    'surface-hovered': '#faeefa',
    'surface-subdued-hovered': '#efe3ef',
    'surface-pressed': '#efe3ef',
    'surface-disabled': '#fff6ff',
    'surface-selected': '#f5f8fc',
    'surface-selected-hovered': '#edf3fa',
    'surface-selected-pressed': '#dbe8f5',
    'surface-attention': '#ffe2bb',
    'surface-attention-subdued': '#fff7ed',
    'surface-negative': '#ffe0da',
    'surface-negative-subdued': '#fff5f3',
    'surface-negative-subdued-hovered': '#fff0ec',
    'surface-negative-subdued-pressed': '#ffe0da',
    'surface-positive': '#c1f2d0',
    'surface-positive-subdued': '#f2fbf5',
    'surface-highlight': '#dbe8f5',
    'surface-highlight-subdued': '#f5f8fc',
    'surface-highlight-subdued-hovered': '#edf3fa',
    'surface-highlight-subdued-pressed': '#dbe8f5',
    'surface-neutral': '#efe3ef',
    'surface-neutral-subdued': '#fff6ff',
    'surface-inverse': '#191619',
    'decorative-surface-1': '#FFC96B',
    'decorative-surface-1-subdued': '#FFE4B5',
    'decorative-content-1': '#7E5700',
    'decorative-surface-2': '#FFC4B0',
    'decorative-surface-2-subdued': '#FFE1D7',
    'decorative-content-2': '#AF294E',
    'decorative-surface-3': '#92E6B5',
    'decorative-surface-3-subdued': '#C9F3DA',
    'decorative-content-3': '#006D41',
    'decorative-surface-4': '#91E0D6',
    'decorative-surface-4-subdued': '#C8EFEB',
    'decorative-content-4': '#006A68',
    'decorative-surface-5': '#FDC9D0',
    'decorative-surface-5-subdued': '#FEE4E7',
    'decorative-content-5': '#AE2B4C',
    'decorative-surface-6': '#7CD4FD',
    'decorative-surface-6-subdued': '#BDE9FE',
    'decorative-content-6': '#065986',
    'decorative-surface-7': '#BDB4FE',
    'decorative-surface-7-subdued': '#DED9FF',
    'decorative-content-7': '#4A1FB8',
  },
  light3: {
    'action-primary': '#2d76b4',
    'action-primary-hovered': '#005693',
    'action-primary-pressed': '#004176',
    'action-primary-subdued': '#f5f8fc',
    'action-primary-subdued-hovered': '#edf3fa',
    'action-primary-subdued-pressed': '#dbe8f5',
    'action-primary-disabled': '#fff6ff',
    'action-neutral': '#faeefa',
    'action-neutral-hovered': '#efe3ef',
    'action-neutral-pressed': '#dcd1dc',
    'action-neutral-subdued': '#efe3ef',
    'action-neutral-subdued-hovered': '#dcd1dc',
    'action-neutral-subdued-pressed': '#dcd1dc',
    'action-neutral-disabled': '#fff6ff',
    'action-destructive': '#d83028',
    'action-destructive-hovered': '#a71613',
    'action-destructive-pressed': '#840a08',
    'action-destructive-subdued': '#fff5f3',
    'action-destructive-subdued-hovered': '#fff0ec',
    'action-destructive-subdued-pressed': '#ffe0da',
    'action-destructive-disabled': '#faeefa',
    background: '#FFFFFF',
    'background-hovered': '#faeefa',
    'background-pressed': '#efe3ef',
    'background-selected': '#efe3ef',
    'background-backdrop': '#00000080',
    'background-overlay': '#ffffff80',
    'background-divider': '#a99fa9',
    content: '#070607',
    'content-subdued': '#585258',
    'content-muted': '#777077',
    'content-hovered': '#191619',
    'content-pressed': '#585258',
    'content-disabled': '#a99fa9',
    'content-on-positive': '#004b22',
    'content-on-attention': '#663200',
    'content-on-highlight': '#00284f',
    'content-on-negative': '#840a08',
    'content-on-negative-hovered': '#580202',
    'content-on-negative-pressed': '#380101',
    'content-primary': '#00284f',
    'content-on-primary': '#FFFFFF',
    'content-on-inverse': '#fff6ff',
    'content-on-destructive': '#FFFFFF',
    'content-on-interactive': '#FFFFFF',
    'content-on-background': '#070607',
    'content-on-background-subdued': '#585258',
    'content-on-background-hovered': '#191619',
    'content-on-background-pressed': '#585258',
    'content-on-background-disabled': '#a99fa9',
    interactive: '#005693',
    'interactive-hovered': '#004176',
    'interactive-pressed': '#00284f',
    'interactive-disabled': '#fff6ff',
    'interactive-destructive': '#d83028',
    'interactive-destructive-hovered': '#a71613',
    'interactive-destructive-pressed': '#840a08',
    'interactive-destructive-disabled': '#fff6ff',
    topbar: '#faeefa',
    'topbar-subdued': '#efe3ef',
    'content-on-topbar': '#070607',
    'line-on-topbar': '#dcd1dc',
    'line-on-topbar-pressed': '#777077',
    link: '#005693',
    'link-hovered': '#004176',
    'link-pressed': '#00284f',
    line: '#dcd1dc',
    'line-subdued': '#efe3ef',
    'line-hovered': '#a99fa9',
    'line-pressed': '#777077',
    'line-selected': '#585258',
    'line-disabled': '#efe3ef',
    'line-transparent': '#0000001a',
    'line-positive': '#00612f',
    'line-positive-subdued': '#90e6af',
    'line-highlight': '#005693',
    'line-highlight-subdued': '#bfd7ee',
    'line-negative': '#a71613',
    'line-negative-subdued': '#ffc7bc',
    'line-negative-disabled': '#ffe0da',
    'line-attention': '#844200',
    'line-attention-subdued': '#ffcb89',
    focused: '#005693',
    skeleton: '#efe3ef',
    surface: '#faeefa',
    'surface-subdued': '#efe3ef',
    'surface-hovered': '#efe3ef',
    'surface-subdued-hovered': '#dcd1dc',
    'surface-pressed': '#dcd1dc',
    'surface-disabled': '#fff6ff',
    'surface-selected': '#f5f8fc',
    'surface-selected-hovered': '#edf3fa',
    'surface-selected-pressed': '#dbe8f5',
    'surface-attention': '#ffe2bb',
    'surface-attention-subdued': '#fff7ed',
    'surface-negative': '#ffe0da',
    'surface-negative-subdued': '#fff5f3',
    'surface-negative-subdued-hovered': '#fff0ec',
    'surface-negative-subdued-pressed': '#ffe0da',
    'surface-positive': '#c1f2d0',
    'surface-positive-subdued': '#f2fbf5',
    'surface-highlight': '#dbe8f5',
    'surface-highlight-subdued': '#f5f8fc',
    'surface-highlight-subdued-hovered': '#edf3fa',
    'surface-highlight-subdued-pressed': '#dbe8f5',
    'surface-neutral': '#efe3ef',
    'surface-neutral-subdued': '#fff6ff',
    'surface-inverse': '#191619',
    'decorative-surface-1': '#FFC96B',
    'decorative-surface-1-subdued': '#FFE4B5',
    'decorative-content-1': '#7E5700',
    'decorative-surface-2': '#FFC4B0',
    'decorative-surface-2-subdued': '#FFE1D7',
    'decorative-content-2': '#AF294E',
    'decorative-surface-3': '#92E6B5',
    'decorative-surface-3-subdued': '#C9F3DA',
    'decorative-content-3': '#006D41',
    'decorative-surface-4': '#91E0D6',
    'decorative-surface-4-subdued': '#C8EFEB',
    'decorative-content-4': '#006A68',
    'decorative-surface-5': '#FDC9D0',
    'decorative-surface-5-subdued': '#FEE4E7',
    'decorative-content-5': '#AE2B4C',
    'decorative-surface-6': '#7CD4FD',
    'decorative-surface-6-subdued': '#BDE9FE',
    'decorative-content-6': '#065986',
    'decorative-surface-7': '#BDB4FE',
    'decorative-surface-7-subdued': '#DED9FF',
    'decorative-content-7': '#4A1FB8',
  },
  dark1: {
    'action-primary': '#4875a1',
    'action-primary-hovered': '#295681',
    'action-primary-pressed': '#194267',
    'action-primary-subdued': '#194267',
    'action-primary-subdued-hovered': '#295681',
    'action-primary-subdued-pressed': '#295681',
    'action-primary-disabled': '#423f42',
    'action-neutral': '#2a272a',
    'action-neutral-hovered': '#423f42',
    'action-neutral-pressed': '#565256',
    'action-neutral-subdued': '#2a272a',
    'action-neutral-subdued-hovered': '#423f42',
    'action-neutral-subdued-pressed': '#565256',
    'action-neutral-disabled': '#423f42',
    'action-destructive': '#bc5044',
    'action-destructive-hovered': '#90372e',
    'action-destructive-pressed': '#712821',
    'action-destructive-subdued': '#4a1712',
    'action-destructive-subdued-hovered': '#712821',
    'action-destructive-subdued-pressed': '#90372e',
    'action-destructive-disabled': '#423f42',
    background: '#181618',
    'background-hovered': '#2a272a80',
    'background-pressed': '#2a272a',
    'background-selected': '#2a272a',
    'background-backdrop': '#00000080',
    'background-overlay': '#00000080',
    'background-divider': '#a69fa6',
    content: '#fdf4fd',
    'content-subdued': '#dad2da',
    'content-muted': '#a69fa6',
    'content-hovered': '#f8eff8',
    'content-pressed': '#dad2da',
    'content-disabled': '#767076',
    'content-on-positive': '#cceed6',
    'content-on-attention': '#ffe1c3',
    'content-on-highlight': '#dee7f1',
    'content-on-negative': '#ffdfda',
    'content-on-negative-hovered': '#ffc6bd',
    'content-on-negative-pressed': '#ffc6bd',
    'content-primary': '#eef3f7',
    'content-on-primary': '#FFFFFF',
    'content-on-inverse': '#181618',
    'content-on-destructive': '#fdf4fd',
    'content-on-interactive': '#fdf4fd',
    'content-on-background': '#fdf4fd',
    'content-on-background-subdued': '#dad2da',
    'content-on-background-hovered': '#f8eff8',
    'content-on-background-pressed': '#dad2da',
    'content-on-background-disabled': '#767076',
    interactive: '#4875a1',
    'interactive-hovered': '#295681',
    'interactive-pressed': '#194267',
    'interactive-disabled': '#181618',
    'interactive-destructive': '#bc5044',
    'interactive-destructive-hovered': '#90372e',
    'interactive-destructive-pressed': '#712821',
    'interactive-destructive-disabled': '#181618',
    topbar: '#2a272a',
    'topbar-subdued': '#423f42',
    'content-on-topbar': '#fdf4fd',
    'line-on-topbar': '#423f42',
    'line-on-topbar-pressed': '#767076',
    link: '#c6d6e7',
    'link-hovered': '#83a5c7',
    'link-pressed': '#4875a1',
    line: '#423f42',
    'line-subdued': '#423f42',
    'line-hovered': '#565256',
    'line-pressed': '#767076',
    'line-selected': '#565256',
    'line-disabled': '#423f42',
    'line-transparent': '#ffffff1a',
    'line-positive': '#051b0e',
    'line-positive-subdued': '#051b0e',
    'line-highlight': '#04182c',
    'line-highlight-subdued': '#04182c',
    'line-negative': '#2f0b08',
    'line-negative-subdued': '#2f0b08',
    'line-negative-disabled': '#712821',
    'line-attention': '#241304',
    'line-attention-subdued': '#241304',
    focused: '#4875a1',
    skeleton: '#423f42',
    surface: '#2a272a',
    'surface-subdued': '#423f42',
    'surface-hovered': '#423f42',
    'surface-subdued-hovered': '#565256',
    'surface-pressed': '#565256',
    'surface-disabled': '#423f42',
    'surface-selected': '#194267',
    'surface-selected-hovered': '#295681',
    'surface-selected-pressed': '#295681',
    'surface-attention': '#5b38144d',
    'surface-attention-subdued': '#3c220a4d',
    'surface-negative': '#7128214d',
    'surface-negative-subdued': '#4a17124d',
    'surface-negative-subdued-hovered': '#2f0b084d',
    'surface-negative-subdued-pressed': '#2f0b084d',
    'surface-positive': '#17492d4d',
    'surface-positive-subdued': '#0b2e1a4d',
    'surface-highlight': '#1942674d',
    'surface-highlight-subdued': '#0a29454d',
    'surface-highlight-subdued-hovered': '#04182c4d',
    'surface-highlight-subdued-pressed': '#04182c4d',
    'surface-neutral': '#565256',
    'surface-neutral-subdued': '#423f42',
    'surface-inverse': '#fdf4fd',
    'decorative-surface-1': '#FFC96B',
    'decorative-surface-1-subdued': '#FFE4B5',
    'decorative-content-1': '#7E5700',
    'decorative-surface-2': '#FFC4B0',
    'decorative-surface-2-subdued': '#FFE1D7',
    'decorative-content-2': '#AF294E',
    'decorative-surface-3': '#92E6B5',
    'decorative-surface-3-subdued': '#C9F3DA',
    'decorative-content-3': '#006D41',
    'decorative-surface-4': '#91E0D6',
    'decorative-surface-4-subdued': '#C8EFEB',
    'decorative-content-4': '#006A68',
    'decorative-surface-5': '#FDC9D0',
    'decorative-surface-5-subdued': '#FEE4E7',
    'decorative-content-5': '#AE2B4C',
    'decorative-surface-6': '#7CD4FD',
    'decorative-surface-6-subdued': '#BDE9FE',
    'decorative-content-6': '#065986',
    'decorative-surface-7': '#BDB4FE',
    'decorative-surface-7-subdued': '#DED9FF',
    'decorative-content-7': '#4A1FB8',
  },
  dark2: {
    'action-primary': '#4875a1',
    'action-primary-hovered': '#295681',
    'action-primary-pressed': '#194267',
    'action-primary-subdued': '#194267',
    'action-primary-subdued-hovered': '#295681',
    'action-primary-subdued-pressed': '#295681',
    'action-primary-disabled': '#423f42',
    'action-neutral': '#181618',
    'action-neutral-hovered': '#2a272a',
    'action-neutral-pressed': '#423f42',
    'action-neutral-subdued': '#2a272a',
    'action-neutral-subdued-hovered': '#423f42',
    'action-neutral-subdued-pressed': '#423f42',
    'action-neutral-disabled': '#2a272a',
    'action-destructive': '#bc5044',
    'action-destructive-hovered': '#90372e',
    'action-destructive-pressed': '#712821',
    'action-destructive-subdued': '#4a1712',
    'action-destructive-subdued-hovered': '#712821',
    'action-destructive-subdued-pressed': '#90372e',
    'action-destructive-disabled': '#423f42',
    background: '#2a272a',
    'background-hovered': '#423f4280',
    'background-pressed': '#423f42',
    'background-selected': '#423f42',
    'background-backdrop': '#00000080',
    'background-overlay': '#00000080',
    'background-divider': '#a69fa6',
    content: '#fdf4fd',
    'content-subdued': '#dad2da',
    'content-muted': '#a69fa6',
    'content-hovered': '#f8eff8',
    'content-pressed': '#dad2da',
    'content-disabled': '#767076',
    'content-on-positive': '#cceed6',
    'content-on-attention': '#ffe1c3',
    'content-on-highlight': '#dee7f1',
    'content-on-negative': '#ffdfda',
    'content-on-negative-hovered': '#ffc6bd',
    'content-on-negative-pressed': '#ffc6bd',
    'content-primary': '#eef3f7',
    'content-on-primary': '#FFFFFF',
    'content-on-inverse': '#181618',
    'content-on-destructive': '#fdf4fd',
    'content-on-interactive': '#fdf4fd',
    'content-on-background': '#fdf4fd',
    'content-on-background-subdued': '#dad2da',
    'content-on-background-hovered': '#f8eff8',
    'content-on-background-pressed': '#dad2da',
    'content-on-background-disabled': '#767076',
    interactive: '#4875a1',
    'interactive-hovered': '#295681',
    'interactive-pressed': '#194267',
    'interactive-disabled': '#181618',
    'interactive-destructive': '#bc5044',
    'interactive-destructive-hovered': '#90372e',
    'interactive-destructive-pressed': '#712821',
    'interactive-destructive-disabled': '#181618',
    topbar: '#181618',
    'topbar-subdued': '#2a272a',
    'content-on-topbar': '#fdf4fd',
    'line-on-topbar': '#423f42',
    'line-on-topbar-pressed': '#767076',
    link: '#c6d6e7',
    'link-hovered': '#83a5c7',
    'link-pressed': '#4875a1',
    line: '#423f42',
    'line-subdued': '#423f42',
    'line-hovered': '#565256',
    'line-pressed': '#767076',
    'line-selected': '#565256',
    'line-disabled': '#423f42',
    'line-transparent': '#ffffff1a',
    'line-positive': '#051b0e',
    'line-positive-subdued': '#051b0e',
    'line-highlight': '#04182c',
    'line-highlight-subdued': '#04182c',
    'line-negative': '#2f0b08',
    'line-negative-subdued': '#2f0b08',
    'line-negative-disabled': '#712821',
    'line-attention': '#241304',
    'line-attention-subdued': '#241304',
    focused: '#4875a1',
    skeleton: '#423f42',
    surface: '#181618',
    'surface-subdued': '#2a272a',
    'surface-hovered': '#2a272a',
    'surface-subdued-hovered': '#423f42',
    'surface-pressed': '#423f42',
    'surface-disabled': '#2a272a',
    'surface-selected': '#194267',
    'surface-selected-hovered': '#295681',
    'surface-selected-pressed': '#295681',
    'surface-attention': '#5b38144d',
    'surface-attention-subdued': '#3c220a4d',
    'surface-negative': '#7128214d',
    'surface-negative-subdued': '#4a17124d',
    'surface-negative-subdued-hovered': '#2f0b084d',
    'surface-negative-subdued-pressed': '#2f0b084d',
    'surface-positive': '#17492d4d',
    'surface-positive-subdued': '#0b2e1a4d',
    'surface-highlight': '#1942674d',
    'surface-highlight-subdued': '#0a29454d',
    'surface-highlight-subdued-hovered': '#04182c4d',
    'surface-highlight-subdued-pressed': '#04182c4d',
    'surface-neutral': '#565256',
    'surface-neutral-subdued': '#423f42',
    'surface-inverse': '#fdf4fd',
    'decorative-surface-1': '#FFC96B',
    'decorative-surface-1-subdued': '#FFE4B5',
    'decorative-content-1': '#7E5700',
    'decorative-surface-2': '#FFC4B0',
    'decorative-surface-2-subdued': '#FFE1D7',
    'decorative-content-2': '#AF294E',
    'decorative-surface-3': '#92E6B5',
    'decorative-surface-3-subdued': '#C9F3DA',
    'decorative-content-3': '#006D41',
    'decorative-surface-4': '#91E0D6',
    'decorative-surface-4-subdued': '#C8EFEB',
    'decorative-content-4': '#006A68',
    'decorative-surface-5': '#FDC9D0',
    'decorative-surface-5-subdued': '#FEE4E7',
    'decorative-content-5': '#AE2B4C',
    'decorative-surface-6': '#7CD4FD',
    'decorative-surface-6-subdued': '#BDE9FE',
    'decorative-content-6': '#065986',
    'decorative-surface-7': '#BDB4FE',
    'decorative-surface-7-subdued': '#DED9FF',
    'decorative-content-7': '#4A1FB8',
  },
}
